import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/popup";

const popupApi = {
  popupList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getPopupDetail(id: string | number, params: any = {}) : Promise<any>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  createPopup(params: any) {
    return api.post(path, params);
  },

  updatePopup(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deletePopup(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default popupApi;
